export default "__VITE_ASSET__BGdF2q9p__"